const categoryFakeTabs = ["Productivity", "Collaboration", "AI", "News"];

export const CategoryFallback = ({ isNavbar = false }) => {
  return categoryFakeTabs.map((value) => {
    if (isNavbar)
      return (
        <button
          key={value}
          disabled
          className="flex items-center text-[14px] font-medium text-[#343434] transition-colors duration-200"
        >
          {value}
          <svg
            className="ms-3 inline-block h-3 w-3 flex-shrink-0"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 10 6"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m1 1 4 4 4-4"
            />
          </svg>
        </button>
      );
    return (
      <button
        key={value}
        disabled
        className="min-w-[100px] rounded-md border border-[#717171] bg-white px-4 py-2 text-sm text-[#202020]"
      >
        {value}
      </button>
    );
  });
};
